import React from "react";
import styles from "./hero.module.scss";

export const UniPageBookingHero = () => {
  return (
    <section className={styles.section_hero}>
      <div className="container">
        <div className={styles.wrapper}>
          <h1>Sign Up to Try Us Out</h1>
          <p>
            Does what we’re offering sound too good to be true? Sign up with us
            for a risk-free trial period, and find out firsthand the difference
            UniSearch can make to your student recruitment outcomes.
          </p>
        </div>
      </div>
    </section>
  );
};

export default UniPageBookingHero;
